import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RH from "../../Services/RH";
import ExcelSearchScreen from "./RHEXCEL";
import { Timestamp } from "firebase/firestore";
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  Box,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  Divider,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Avatar,
  Chip,
  Paper,
  useTheme,
  useMediaQuery,
  LinearProgress,
  CircularProgress,
  InputAdornment,
  alpha,
  Badge,
  Fade,
  Zoom,
  Grow,
  Skeleton,
  Alert,
  AlertTitle,
  
  Breadcrumbs,
  Link
} from "@mui/material";
import {
  Edit as EditIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  AccountCircle as AccountCircleIcon,
  AttachMoney as AttachMoneyIcon,
  Work as WorkIcon,
  Person as PersonIcon,
  ErrorOutline as ErrorOutlineIcon,
  Today as TodayIcon,
  Event as EventIcon,
  PersonPinCircle as PersonPinIcon,
  BusinessCenter as BusinessCenterIcon,
  Paid as PaidIcon,
  CalendarMonth as CalendarMonthIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  PendingActions as PendingActionsIcon,
  DeleteOutline as DeleteOutlineIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  Phone as PhoneIcon,
  Fingerprint as FingerprintIcon,
  Favorite as FavoriteIcon,
  Celebration as CelebrationIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Receipt as ReceiptIcon,
  Download as DownloadIcon,
  Print as PrintIcon,
  Share as ShareIcon,
  MoreVert as MoreVertIcon
} from "@mui/icons-material";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parseISO } from 'date-fns';
import fr from 'date-fns/locale/fr';
import { motion, AnimatePresence } from "framer-motion";

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

const statusColors = {
  Celibataire: {
    primary: "#2196F3",
    light: "#E3F2FD",
    icon: <PersonIcon />
  },
  Marie: {
    primary: "#4CAF50",
    light: "#E8F5E9",
    icon: <FavoriteIcon />
  },
  "M+1": {
    primary: "#FF9800",
    light: "#FFF3E0",
    icon: <CelebrationIcon />
  },
  "M+2": {
    primary: "#00BCD4",
    light: "#E0F7FA",
    icon: <CelebrationIcon />
  },
  "M+3": {
    primary: "#9C27B0",
    light: "#F3E5F5",
    icon: <CelebrationIcon />
  },
  "M+4": {
    primary: "#F44336",
    light: "#FFEBEE",
    icon: <CelebrationIcon />
  }
};

const WorkerDetails = ({ sidebarOpen }) => {
  const { workerId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [worker, setWorker] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [accompteAmount, setAccompteAmount] = useState("");
  const [accompteDate, setAccompteDate] = useState("");
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editedWorker, setEditedWorker] = useState({});
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedMonthYear, setSelectedMonthYear] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [loading, setLoading] = useState(true);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedAccompte, setSelectedAccompte] = useState(null);
  const [deleteAccompteDialog, setDeleteAccompteDialog] = useState(false);

  // Responsive padding based on sidebar
  const mainContentPadding = {
    pl: sidebarOpen ? (isMobile ? 1 : 32) : 2,
    pr: 2,
    transition: theme.transitions.create(['padding'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })
  };

  const DetailItem = ({ label, value, icon }) => (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'space-between',
      p: 1,
      borderRadius: 2,
      bgcolor: alpha(theme.palette.primary.main, 0.02),
      '&:hover': {
        bgcolor: alpha(theme.palette.primary.main, 0.05)
      }
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon && React.cloneElement(icon, { sx: { fontSize: 18, color: theme.palette.primary.main } })}
        <Typography variant="body2" color="textSecondary">{label}:</Typography>
      </Box>
      <Typography variant="body1" fontWeight="600" sx={{ color: theme.palette.text.primary }}>
        {value || '-'}
      </Typography>
    </Box>
  );

  useEffect(() => {
    const fetchWorkerDetails = async () => {
      setLoading(true);
      try {
        const workerData = await RH.getWorker(workerId);
        setWorker(workerData);
      } catch (error) {
        console.error("Erreur lors de la récupération des détails du travailleur :", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchWorkerDetails();
  }, [workerId]);

  const handleDialogOpen = () => setIsDialogOpen(true);
  
  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setAccompteAmount("");
    setAccompteDate("");
  };

  const handleEditDialogOpen = () => {
    setEditedWorker({ ...worker });
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = () => {
    setIsEditDialogOpen(false);
    setEditedWorker({});
  };

  const handleAddAccompte = async () => {
    if (!accompteAmount || isNaN(accompteAmount) || parseFloat(accompteAmount) <= 0) {
      alert("Veuillez entrer un montant valide");
      return;
    }

    try {
      const formattedDate = new Date(accompteDate);
      await RH.addAccompte(workerId, parseFloat(accompteAmount), formattedDate);
      const updatedWorker = await RH.getWorker(workerId);
      setWorker(updatedWorker);
      handleDialogClose();
    } catch (error) {
      console.error("Error adding accompte:", error.message);
      alert("Échec de l'ajout de l'acompte. Veuillez réessayer.");
    }
  };

  const handleSaveWorkerDetails = async () => {
    try {
      await RH.editWorker(workerId, editedWorker);
      const updatedWorker = await RH.getWorker(workerId);
      setWorker(updatedWorker);
      handleEditDialogClose();
      window.location.reload();
    } catch (error) {
      console.error("Erreur lors de la mise à jour des détails du travailleur:", error.message);
      alert("Échec de la mise à jour des informations du travailleur. Veuillez réessayer.");
    }
  };

  const handleDeleteAccompte = async () => {
    if (!selectedAccompte) return;
    
    try {
      await RH.deleteAccompte(workerId, selectedAccompte.id);
      const updatedWorker = await RH.getWorker(workerId);
      setWorker(updatedWorker);
      setDeleteAccompteDialog(false);
      setSelectedAccompte(null);
    } catch (error) {
      console.error("Error deleting accompte:", error.message);
      alert("Échec de la suppression de l'acompte. Veuillez réessayer.");
    }
  };

  const handleDeleteWorker = async () => {
    try {
      await RH.deleteWorker(workerId);
      navigate("/workers");
    } catch (error) {
      console.error("Error deleting worker:", error.message);
      alert("Échec de la suppression de l'employé. Veuillez réessayer.");
    }
  };

  const formatDate = (timestamp) => {
    if (timestamp instanceof Timestamp) {
      return new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(timestamp.toDate());
    }
    return "Invalid Date";
  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const totalAccomptes = worker?.accompte
    ?.filter(acc => {
      if (!acc.date?.seconds) return false;
      const accDate = new Date(acc.date.seconds * 1000);
      return accDate.getMonth() === currentMonth && accDate.getFullYear() === currentYear;
    })
    .reduce((sum, acc) => sum + (acc.amount || 0), 0) || 0;

  const filteredAccomptes = worker?.accompte
    ?.filter(acc => {
      if (!acc.date?.seconds) return false;
      const accDate = new Date(acc.date.seconds * 1000);
      const accMonthYear = `${accDate.getFullYear()}-${String(accDate.getMonth() + 1).padStart(2, '0')}`;
      return accMonthYear === selectedMonthYear;
    }) || [];

  const remainingSalary = worker ? worker.salary - totalAccomptes : 0;
  const progressPercentage = worker ? (totalAccomptes / worker.salary) * 100 : 0;

  if (loading) {
    return (
      <Box sx={{ ...mainContentPadding, pt: 3 }}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            {[1, 2, 3].map((item) => (
              <Grid item xs={12} key={item}>
                <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 4 }} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }

  if (!worker) {
    return (
      <Box sx={{ ...mainContentPadding, pt: 3 }}>
        <Container maxWidth="lg">
          <Zoom in={true}>
            <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 4 }}>
              <WarningIcon sx={{ fontSize: 80, color: '#f44336', mb: 2 }} />
              <Typography variant="h4" gutterBottom>
                Employé non trouvé
              </Typography>
              <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                L'employé que vous recherchez n'existe pas ou a été supprimé.
              </Typography>
              <Button
                variant="contained"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/rh')}
                sx={{ borderRadius: 2 }}
              >
                Retour à la liste
              </Button>
            </Paper>
          </Zoom>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      ...mainContentPadding,
      pt: 3,
      minHeight: '100vh',
      position: 'relative',
      overflowX: 'hidden'
    }}>
      {/* Background Decoration */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 50% 50%, rgba(102,126,234,0.03) 0%, transparent 50%)',
        pointerEvents: 'none',
        zIndex: 0
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Breadcrumb Navigation */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link color="inherit" href="#" onClick={() => navigate('/rh')}>
            Gestion d'Équipe
          </Link>
          <Typography color="text.primary">{worker.name} {worker.prenom}</Typography>
        </Breadcrumbs>

        {/* Header with Actions */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          mb: 4,
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              onClick={() => navigate('/rh')}
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Profil Employé
            </Typography>
          </Box>
          
        
        </Box>

        <motion.div
          initial="initial"
          animate="animate"
          variants={staggerContainer}
        >
          {/* Excel Search Section */}
          <motion.div variants={fadeInUp}>
            <Paper sx={{ mb: 4, borderRadius: 3, overflow: 'hidden' }}>
              <ExcelSearchScreen worker={worker} selectedWorkerId={worker.id} />
            </Paper>
          </motion.div>

          {/* Worker Profile Card */}
          <motion.div variants={fadeInUp}>
            <Card sx={{ 
              mb: 4, 
              borderRadius: 4,
              background: 'linear-gradient(145deg, #FFFFFF 0%, #F8F9FA 100%)',
              border: '1px solid #E0E0E0',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                background: 'linear-gradient(90deg, #667eea, #764ba2, #FFD700, #FFA500)',
                backgroundSize: '300% 300%',
                animation: 'gradient 3s ease infinite',
              },
              '@keyframes gradient': {
                '0%': { backgroundPosition: '0% 50%' },
                '50%': { backgroundPosition: '100% 50%' },
                '100%': { backgroundPosition: '0% 50%' },
              }
            }}>
              <CardContent sx={{ p: 4 }}>
                <Grid container spacing={4}>
                  {/* Profile Section */}
                  <Grid item xs={12} md={8}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexDirection: { xs: 'column', sm: 'row' } }}>
                      <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              bgcolor: '#4caf50',
                              borderRadius: '50%',
                              border: '3px solid white',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                            }}
                          />
                        }
                      >
                        <Avatar
                          sx={{
                            width: 140,
                            height: 140,
                            background: `linear-gradient(135deg, ${statusColors[worker.statue]?.primary || '#667eea'}, ${alpha(statusColors[worker.statue]?.primary || '#667eea', 0.7)})`,
                            fontSize: '3rem',
                            fontWeight: 600,
                            border: '4px solid white',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
                          }}
                        >
                          {worker.name[0]}{worker.prenom[0]}
                        </Avatar>
                      </Badge>

                      <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1, flexWrap: 'wrap' }}>
                          <Typography variant="h3" sx={{ fontWeight: 800, color: '#1A2B3C' }}>
                            {worker.name} {worker.prenom}
                          </Typography>
                          <Chip
                            label={worker.statue}
                            sx={{
                              background: statusColors[worker.statue]?.primary,
                              color: 'white',
                              fontWeight: 600,
                              px: 1
                            }}
                          />
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <WorkIcon sx={{ color: '#667eea' }} />
                            <Typography variant="h6" sx={{ color: '#5F6B7A', fontWeight: 500 }}>
                              {worker.role}
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PersonPinIcon sx={{ color: '#667eea' }} />
                            <Typography variant="h6" sx={{ color: '#5F6B7A', fontWeight: 500 }}>
                              ID: {worker.cin}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Action Buttons */}
                  <Grid item xs={12} md={4}>
                    <Box sx={{ 
                      display: 'flex', 
                      gap: 2, 
                      justifyContent: { xs: 'center', md: 'flex-end' },
                      alignItems: 'center',
                      height: '100%'
                    }}>
                      <Tooltip title="Modifier" arrow>
                        <Button
                          variant="contained"
                          startIcon={<EditIcon />}
                          onClick={handleEditDialogOpen}
                          sx={{
                            py: 1.5,
                            px: 3,
                            borderRadius: 2,
                            background: 'linear-gradient(45deg, #667eea, #764ba2)',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
                            }
                          }}
                        >
                          Modifier
                        </Button>
                      </Tooltip>
                      <Tooltip title="Supprimer" arrow>
                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<DeleteIcon />}
                          onClick={() => setIsDeleteDialogOpen(true)}
                          sx={{
                            py: 1.5,
                            px: 3,
                            borderRadius: 2,
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 10px 20px rgba(244,67,54,0.3)'
                            }
                          }}
                        >
                          Supprimer
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </motion.div>

          {/* Financial Summary Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card
                  onMouseEnter={() => setHoveredCard('salary')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    transform: hoveredCard === 'salary' ? 'translateY(-5px)' : 'none',
                    boxShadow: hoveredCard === 'salary' ? '0 20px 30px rgba(102,126,234,0.3)' : '0 10px 20px rgba(0,0,0,0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
                      transition: 'left 0.6s',
                    },
                    '&:hover::before': {
                      left: '100%'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, opacity: 0.9 }}>
                      Salaire Mensuel
                    </Typography>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                      <AttachMoneyIcon />
                    </Avatar>
                  </Box>
                  <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
                    {worker.salary} TND
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Rémunération de base
                  </Typography>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card
                  onMouseEnter={() => setHoveredCard('paid')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    transform: hoveredCard === 'paid' ? 'translateY(-5px)' : 'none',
                    boxShadow: hoveredCard === 'paid' ? '0 20px 30px rgba(76,175,80,0.3)' : '0 10px 20px rgba(0,0,0,0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
                      transition: 'left 0.6s',
                    },
                    '&:hover::before': {
                      left: '100%'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, opacity: 0.9 }}>
                      Total Versé
                    </Typography>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                      <CheckCircleIcon />
                    </Avatar>
                  </Box>
                  <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
                    {totalAccomptes.toFixed(3)} TND
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Acomptes versés ce mois
                  </Typography>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card
                  onMouseEnter={() => setHoveredCard('remaining')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    background: remainingSalary > 0 
                      ? 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)'
                      : 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    transform: hoveredCard === 'remaining' ? 'translateY(-5px)' : 'none',
                    boxShadow: hoveredCard === 'remaining' ? '0 20px 30px rgba(255,152,0,0.3)' : '0 10px 20px rgba(0,0,0,0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-100%',
                      width: '100%',
                      height: '100%',
                      background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
                      transition: 'left 0.6s',
                    },
                    '&:hover::before': {
                      left: '100%'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, opacity: 0.9 }}>
                      Reste à Payer
                    </Typography>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                      {remainingSalary > 0 ? <PendingActionsIcon /> : <CheckCircleIcon />}
                    </Avatar>
                  </Box>
                  <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
                    {remainingSalary.toFixed(3)} TND
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    {remainingSalary > 0 ? 'Solde restant' : 'Salaire complet'}
                  </Typography>
                </Card>
              </motion.div>
            </Grid>
          </Grid>

          {/* Personal Information Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card sx={{ borderRadius: 3, height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonPinIcon sx={{ color: '#667eea' }} />
                      Informations Personnelles
                    </Typography>
                    <Stack spacing={1.5}>
                      <DetailItem 
                        label="CIN" 
                        value={worker.cin} 
                        icon={<FingerprintIcon />}
                      />
                      <DetailItem 
                        label="Téléphone" 
                        value={worker.num} 
                        icon={<PhoneIcon />}
                      />
                      <DetailItem 
                        label="Situation Familiale" 
                        value={worker.statue} 
                        icon={statusColors[worker.statue]?.icon || <PersonIcon />}
                      />
                    </Stack>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card sx={{ borderRadius: 3, height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BusinessCenterIcon sx={{ color: '#667eea' }} />
                      Informations Professionnelles
                    </Typography>
                    <Stack spacing={1.5}>
                      <DetailItem 
                        label="Poste" 
                        value={worker.role} 
                        icon={<WorkIcon />}
                      />
                      <DetailItem 
                        label="Département" 
                        value="Restaurant" 
                        icon={<BusinessCenterIcon />}
                      />
                      {worker.numcnss && (
                        <DetailItem 
                          label="CNSS" 
                          value={worker.numcnss} 
                          icon={<ReceiptIcon />}
                        />
                      )}
                    </Stack>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} md={4}>
              <motion.div variants={fadeInUp}>
                <Card sx={{ borderRadius: 3, height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <TrendingUpIcon sx={{ color: '#667eea' }} />
                      Progression Salariale
                    </Typography>
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <CircularProgress
                          variant="determinate"
                          value={progressPercentage}
                          size={120}
                          thickness={4}
                          sx={{ color: progressPercentage > 75 ? '#4CAF50' : progressPercentage > 50 ? '#FF9800' : '#f44336' }}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
                            {progressPercentage.toFixed(0)}%
                          </Typography>
                        </Box>
                      </Box>
                      <Typography variant="body2" sx={{ mt: 2, color: '#5F6B7A' }}>
                        Salaire versé ce mois
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          </Grid>

          {/* Accomptes Section */}
          <motion.div variants={fadeInUp}>
            <Card sx={{ 
              mb: 4, 
              borderRadius: 4,
              background: '#FFFFFF',
              border: '1px solid #E0E0E0',
              overflow: 'hidden'
            }}>
              {/* Header */}
              <Box sx={{ 
                p: 3, 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white'
              }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                        <PaidIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                          Gestion des Acomptes
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.9 }}>
                          {format(parseISO(selectedMonthYear + '-01'), 'MMMM yyyy', { locale: fr })}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box sx={{ 
                      display: 'flex', 
                      gap: 2, 
                      justifyContent: { xs: 'flex-start', md: 'flex-end' },
                      alignItems: 'center'
                    }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                        <DatePicker
                          views={['year', 'month']}
                          value={parseISO(selectedMonthYear + '-01')}
                          onChange={(newDate) => {
                            if (newDate) {
                              setSelectedMonthYear(format(newDate, 'yyyy-MM'));
                            }
                          }}
                          inputFormat="MMMM yyyy"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              sx={{
                                bgcolor: 'rgba(255,255,255,0.1)',
                                borderRadius: 2,
                                width: 200,
                                '& .MuiInputBase-root': {
                                  color: 'white',
                                  '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
                                  '&:hover fieldset': { borderColor: 'white' }
                                },
                                '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' }
                              }}
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CalendarMonthIcon sx={{ color: 'white' }} />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                      </LocalizationProvider>

                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleDialogOpen}
                        sx={{
                          bgcolor: 'white',
                          color: '#667eea',
                          '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.9)',
                            transform: 'translateY(-2px)'
                          }
                        }}
                      >
                        Nouvel Acompte
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Summary Cards */}
              <Box sx={{ p: 3, bgcolor: '#F8F9FA' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Paper sx={{ 
                      p: 2, 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 2,
                      bgcolor: alpha('#4CAF50', 0.1),
                      borderRadius: 2
                    }}>
                      <Avatar sx={{ bgcolor: '#4CAF50' }}>
                        <PaidIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#5F6B7A' }}>Total Versé</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#4CAF50' }}>
                          {totalAccomptes.toFixed(3)} TND
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Paper sx={{ 
                      p: 2, 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 2,
                      bgcolor: alpha('#FF9800', 0.1),
                      borderRadius: 2
                    }}>
                      <Avatar sx={{ bgcolor: '#FF9800' }}>
                        <PendingActionsIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#5F6B7A' }}>Reste à Payer</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#FF9800' }}>
                          {remainingSalary.toFixed(3)} TND
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Paper sx={{ 
                      p: 2, 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 2,
                      bgcolor: alpha('#2196F3', 0.1),
                      borderRadius: 2
                    }}>
                      <Avatar sx={{ bgcolor: '#2196F3' }}>
                        <ReceiptIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="body2" sx={{ color: '#5F6B7A' }}>Nombre de Versements</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#2196F3' }}>
                          {filteredAccomptes.length}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              {/* Transactions List */}
              <CardContent>
                {filteredAccomptes.length > 0 ? (
                  <List sx={{ 
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 3,
                    overflow: 'hidden'
                  }}>
                    <AnimatePresence>
                      {filteredAccomptes.map((accompte, index) => (
                        <motion.div
                          key={index}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: 20 }}
                          transition={{ delay: index * 0.05 }}
                        >
                          <Paper 
                            elevation={0}
                            sx={{
                              p: 2,
                              borderBottom: index < filteredAccomptes.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                              transition: 'all 0.2s ease',
                              '&:hover': { 
                                bgcolor: alpha('#667eea', 0.05),
                                transform: 'translateX(5px)'
                              }
                            }}
                          >
                            <Grid container alignItems="center" spacing={2}>
                              <Grid item xs={12} sm={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                  <Avatar sx={{ bgcolor: '#4CAF50', width: 32, height: 32 }}>
                                    <PaidIcon sx={{ fontSize: 18 }} />
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body2" fontWeight={500}>
                                      {formatDate(accompte.date)}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                      Versement #{index + 1}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                              
                              <Grid item xs={12} sm={4}>
                                <Typography variant="body2" color="textSecondary">
                                  Acompte mensuel
                                </Typography>
                              </Grid>
                              
                              <Grid item xs={12} sm={4}>
                                <Box sx={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  justifyContent: 'flex-end',
                                  gap: 2
                                }}>
                                  <Typography 
                                    variant="h6" 
                                    sx={{ 
                                      fontWeight: 700, 
                                      color: '#4CAF50'
                                    }}
                                  >
                                    {accompte.amount} TND
                                  </Typography>
                                  <Tooltip title="Supprimer" arrow>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedAccompte(accompte);
                                        setDeleteAccompteDialog(true);
                                      }}
                                      sx={{
                                        color: '#f44336',
                                        '&:hover': {
                                          bgcolor: alpha('#f44336', 0.1),
                                          transform: 'scale(1.1)'
                                        }
                                      }}
                                    >
                                      <DeleteOutlineIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </Grid>
                            </Grid>
                          </Paper>
                        </motion.div>
                      ))}
                    </AnimatePresence>
                  </List>
                ) : (
                  <Fade in={true}>
                    <Paper sx={{ 
                      p: 6, 
                      textAlign: 'center', 
                      bgcolor: '#F8F9FA',
                      borderRadius: 3
                    }}>
                      <PaidIcon sx={{ fontSize: 80, color: '#B0BEC5', mb: 2 }} />
                      <Typography variant="h6" sx={{ color: '#5F6B7A', mb: 1 }}>
                        Aucun acompte enregistré
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#9AA6B2', mb: 3 }}>
                        Cliquez sur "Nouvel Acompte" pour effectuer un versement
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleDialogOpen}
                        sx={{ borderRadius: 2 }}
                      >
                        Premier Acompte
                      </Button>
                    </Paper>
                  </Fade>
                )}
              </CardContent>
            </Card>
          </motion.div>
        </motion.div>

        {/* Add Accompte Dialog */}
        <Dialog 
          open={isDialogOpen} 
          onClose={handleDialogClose} 
          fullWidth 
          maxWidth="xs"
          TransitionComponent={Zoom}
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: 'hidden'
            }
          }}
        >
          <DialogTitle sx={{ 
            bgcolor: '#667eea',
            color: 'white',
            py: 3
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                <PaidIcon />
              </Avatar>
              <Box>
                <Typography variant="h6" fontWeight={700}>
                  Nouvel Acompte
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                  Ajouter un versement pour {worker.name} {worker.prenom}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
        <br></br>
          <DialogContent sx={{ pt: 4, px: 3 }}>
            <Stack spacing={3}>
              <TextField
                autoFocus
                label="Montant"
                type="number"
                fullWidth
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  ),
                  endAdornment: <InputAdornment position="end">TND</InputAdornment>
                }}
                value={accompteAmount}
                onChange={(e) => setAccompteAmount(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    '&:hover fieldset': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
              <TextField
                label="Date"
                type="date"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarMonthIcon sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  )
                }}
                value={accompteDate}
                onChange={(e) => setAccompteDate(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    '&:hover fieldset': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Stack>
          </DialogContent>

          <DialogActions sx={{ p: 3, bgcolor: '#F8F9FA' }}>
            <Button 
              onClick={handleDialogClose} 
              variant="outlined"
              startIcon={<CancelIcon />}
              sx={{ borderRadius: 2, px: 3 }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleAddAccompte}
              variant="contained"
              startIcon={<SaveIcon />}
              sx={{
                borderRadius: 2,
                px: 3,
                background: 'linear-gradient(45deg, #667eea, #764ba2)',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
                }
              }}
            >
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Worker Dialog */}
        <Dialog 
          open={isEditDialogOpen} 
          onClose={handleEditDialogClose} 
          fullWidth 
          maxWidth="md"
          TransitionComponent={Zoom}
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: 'hidden'
            }
          }}
        >
          <DialogTitle sx={{ 
            bgcolor: '#667eea',
            color: 'white',
            py: 3
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                <EditIcon />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight={700}>
                  Modifier Employé
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                  Mettre à jour les informations de {worker.name} {worker.prenom}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ pt: 4, px: 3 }}>
            <br></br>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Prénom"
                  fullWidth
                  variant="outlined"
                  value={editedWorker.name || ""}
                  onChange={(e) => setEditedWorker({ ...editedWorker, name: e.target.value })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ color: '#667eea' }} />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Nom"
                  fullWidth
                  variant="outlined"
                  value={editedWorker.prenom || ""}
                  onChange={(e) => setEditedWorker({ ...editedWorker, prenom: e.target.value })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ color: '#667eea' }} />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Poste</InputLabel>
                  <Select
                    label="Poste"
                    value={editedWorker.role || ""}
                    onChange={(e) => setEditedWorker({ ...editedWorker, role: e.target.value })}
                    startAdornment={
                      <InputAdornment position="start">
                        <WorkIcon sx={{ color: '#667eea', ml: 1 }} />
                      </InputAdornment>
                    }
                  >
                    {[
                      "Gérant",
                      "Chef de cuisine",
                      "Cuisinier",
                      "Aide-cuisinier",
                      "Serveur",
                      "Barman",
                      "Barmaid",
                      "Plongeur",
                      "Hôte",
                      "Hôtesse d'accueil",
                      "Responsable de salle"
                    ].map((role) => (
                      <MenuItem key={role} value={role}>
                        {role}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Situation Familiale</InputLabel>
                  <Select
                    label="Situation Familiale"
                    value={editedWorker.statue}
                    onChange={(e) => setEditedWorker({ ...editedWorker, statue: e.target.value })}
                    startAdornment={
                      <InputAdornment position="start">
                        <FavoriteIcon sx={{ color: '#667eea', ml: 1 }} />
                      </InputAdornment>
                    }
                  >
                    {Object.keys(statusColors).map((status) => (
                      <MenuItem key={status} value={status}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {statusColors[status].icon}
                          <span style={{ color: statusColors[status].primary }}>
                            {status}
                          </span>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Salaire (TND)"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={editedWorker.salary || ""}
                  onChange={(e) => setEditedWorker({ ...editedWorker, salary: e.target.value })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyIcon sx={{ color: '#667eea' }} />
                      </InputAdornment>
                    ),
                    endAdornment: <InputAdornment position="end">TND</InputAdornment>
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="CIN"
                  fullWidth
                  variant="outlined"
                  value={editedWorker.cin || ""}
                  onChange={(e) => setEditedWorker({ ...editedWorker, cin: e.target.value })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <FingerprintIcon sx={{ color: '#667eea' }} />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: 3, bgcolor: '#F8F9FA' }}>
            <Button 
              onClick={handleEditDialogClose}
              variant="outlined"
              startIcon={<CancelIcon />}
              sx={{ borderRadius: 2, px: 3 }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleSaveWorkerDetails}
              variant="contained"
              startIcon={<SaveIcon />}
              sx={{
                borderRadius: 2,
                px: 3,
                background: 'linear-gradient(45deg, #667eea, #764ba2)',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
                }
              }}
            >
              Sauvegarder
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Accompte Confirmation Dialog */}
        <Dialog
          open={deleteAccompteDialog}
          onClose={() => setDeleteAccompteDialog(false)}
          TransitionComponent={Zoom}
          PaperProps={{
            sx: {
              borderRadius: 4,
              width: 400,
              textAlign: 'center'
            }
          }}
        >
          <DialogTitle sx={{ pt: 4 }}>
            <WarningIcon sx={{ fontSize: 60, color: '#f44336', mb: 2 }} />
            <Typography variant="h5" fontWeight={700}>
              Supprimer l'acompte
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ color: '#5F6B7A' }}>
              Êtes-vous sûr de vouloir supprimer cet acompte de
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ mt: 1, color: '#f44336' }}>
              {selectedAccompte?.amount} TND
            </Typography>
            <Typography variant="body2" color="error" sx={{ mt: 2, fontStyle: 'italic' }}>
              Cette action est irréversible
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', pb: 4, pt: 2 }}>
            <Button
              onClick={() => setDeleteAccompteDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2, px: 4, mr: 2 }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleDeleteAccompte}
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
              sx={{ borderRadius: 2, px: 4 }}
            >
              Supprimer
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Worker Confirmation Dialog */}
        <Dialog
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
          TransitionComponent={Zoom}
          PaperProps={{
            sx: {
              borderRadius: 4,
              width: 400,
              textAlign: 'center'
            }
          }}
        >
          <DialogTitle sx={{ pt: 4 }}>
            <ErrorOutlineIcon sx={{ fontSize: 60, color: '#f44336', mb: 2 }} />
            <Typography variant="h5" fontWeight={700}>
              Supprimer l'employé
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ color: '#5F6B7A' }}>
              Êtes-vous sûr de vouloir supprimer définitivement
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ mt: 1 }}>
              {worker.name} {worker.prenom}
            </Typography>
            <Typography variant="body2" color="error" sx={{ mt: 2, fontStyle: 'italic' }}>
              Cette action supprimera toutes les données associées
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center', pb: 4, pt: 2 }}>
            <Button
              onClick={() => setIsDeleteDialogOpen(false)}
              variant="outlined"
              sx={{ borderRadius: 2, px: 4, mr: 2 }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleDeleteWorker}
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
              sx={{ borderRadius: 2, px: 4 }}
            >
              Supprimer
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
};

export default WorkerDetails;